<template>
	<div class="nav">
		<div class="logo" :style="{backgroundImage: 'url('+logo+')'}"></div>
		<ul>
			<router-link :to="{path: '/', name: ''}" @click="effectOn('home')">
				<li :class="{active: pagOn == 'home'}">
					<b></b>
					<div class="icon rot">
						<div class="bar"></div>
						<div class="bar"></div>
						<div class="bar"></div>
					</div>
					<p>Ranking</p>
					<b></b>
				</li>
			</router-link>
			<!-- <router-link :to="{path: '/dados', name: 'Dados'}" @click="effectOn('dado')">
				<li :class="{active: pagOn == 'dado'}">
					<b></b>
					<div class="icon"><i class="fa-solid fa-star"></i></div>
					<p>Ranking de locutores</p>
					<b></b>
				</li>
			</router-link>
			<router-link :to="{path: '/rank-fs', name: 'RankFs'}" @click="effectOn('rankfs')">
				<li :class="{active: pagOn == 'rankfs'}">
					<b></b>
					<div class="icon"><i class="fa-solid fa-star"></i></div>
					<p>Ranking de fã-sites</p>
					<b></b>
				</li>
			</router-link> -->
			<router-link :to="{path: '/imager', name: 'Imager'}" @click="effectOn('imager')">
				<li :class="{active: pagOn == 'imager'}">
					<b></b>
					<div class="icon"><i class="fas fa-male"></i></div>
					<p>Habbo imager</p>
					<b></b>
				</li>
			</router-link>
			<router-link :to="{name: 'Page', params: {page: 'fansite'}}" @click="effectOn('fansite')">
				<li :class="{active: pagOn == 'fansite'}">
					<b></b>
					<div class="icon"><i class="fa-solid fa-sitemap"></i></div>
					<p>Antigas Fã sites</p>
					<b></b>
				</li>
			</router-link>
			<router-link :to="{name: 'Page', params: {page: 'sobre'}}" @click="effectOn('page')">
				<li :class="{active: pagOn == 'page'}">
					<b></b>
					<div class="icon"><i class="fa-solid fa-diagram-project"></i></div>
					<p>Sobre o projeto</p>
					<b></b>
				</li>
			</router-link>
		</ul>
		<div class="about">
			<p>
				Desenvolvido com ❤ por <strong><a href="https://twitter.com/WurxHabbo" target="_blank" rel="noopener noreferrer">Luan Wieyra(Wurx)</a></strong><br>
				e por <strong><a href="https://twitter.com/ZiniiBr" target="_blank" rel="noopener noreferrer">Paulo Ferraço(ZiniiBr)</a></strong>.
			</p>
		</div>
	</div>
</template>

<script>

export default {
	name: 'MenuItem',
	data() {
		return {
			logo: 'https://rank.pauloferraco.com.br/img/logo.png',
			pagOn: 'home'
		}
	},
	methods: {
		effectOn(a){
			this.pagOn = a;
		}
	},
	mounted: function() {
	}
}
</script>

<style scoped>
.nav {
	position: fixed;
	width: 18%;
	height: 100%;
	background-color: var(--color1);
	z-index: 1;
	top: 0;
}

.nav .logo {
	position: relative;
	float: left;
	width: 100%;
	height: 70px;
	background-position: center;
	background-repeat: no-repeat;
	margin: 110px 0 30px 0;
}

.nav ul {
	float: left;
	width: 100%;
	height: auto;
	list-style: none;
}

.nav ul li {
	float: left;
	width: calc(100% - 40px);
	height: 44px;
	margin: 40px 0 0 40px;
	transition: 0 all ease-in;
}
.nav ul li:hover,
.nav ul li.active {
	background-color: #F9FAFB;
	border-radius: 20px 0 0 20px;
}
.nav ul li.active b:nth-child(1),
.nav ul li:hover b:nth-child(1)  {
	float: left;
	margin-top: -20px;
	height: 20px;
	width: 100%;
	background-color: #F9FAFB;
	display: none;
}
.nav ul li:hover b:nth-child(1),
.nav ul li.active b:nth-child(1)  {display: block;}

.nav ul li.active b:nth-child(1)::before,
.nav ul li:hover b:nth-child(1)::before {
	content: '';
	position: relative;
	top: 0px;
	left: 0;
	width: 100%;
	height: 20px;
	border-bottom-right-radius: 20px;
	background-color: var(--color1);
	display: none;
}
.nav ul li:hover b:nth-child(1)::before,
.nav ul li.active b:nth-child(1)::before {display: block;}

.nav ul li.active b:last-of-type,
.nav ul li:hover b:last-of-type {
	position: relative;
	left: 0;
	bottom: 0;
	height: 20px;
	width: 100%;
	background-color: #F9FAFB;
	display: none;
}
.nav ul li.active b:last-of-type,
.nav ul li:hover b:last-of-type { display: block;}

.nav ul li.active b:last-of-type::before,
.nav ul li:hover b:last-of-type::before {
	content: '';
	position: relative;
	width: 100%;
	height: 20px;
	bottom: 0;
	left: 0;
	border-top-right-radius: 20px;
	background-color: var(--color1);
	display: none;
}
.nav ul li.active b:last-of-type::before,
.nav ul li:hover b:last-of-type::before {display: block;}

.nav li .icon {
	float: left;
	width: 30px;
	height: 22px;
	color: #fff;
	font-size: 15px;
	margin: 12px 0 0 80px;
}
.nav li:hover .icon,
.nav li.active .icon {color: rgb(56, 56, 56)}

.nav li .icon.rot {transform: rotateX(180deg);}
.nav li .icon .bar {
	float: left;
	width: 3px;
	height: 80%;
	background-color: #fff;
	border-radius: 2px;
	margin-left: 3px;
	animation: live 4s infinite;
}
.nav li:hover .icon .bar,
.nav li.active .icon .bar {
	background-color: rgb(56, 56, 56);
}
.nav li .icon .bar:last-of-type {animation-duration: 3.5s;}
.nav li .icon .bar:first-of-type {animation-duration: 4.5s;}

@keyframes live {
	0% {
		height: 80%;
	}
	50% {
		height: 1px;
	}
	100% {
		height: 80%;
	}
}

.nav li p {
	width: auto;
	font-size: 15px;
	font-size: 400;
	color: #fff;
	line-height: 44px;
	text-align: center;
	transition: .2s all linear;
}
.nav li:hover p,
.nav li.active p {
	font-weight: 600;
	color: rgb(56, 56, 56);
}

</style>